import React from 'react';

import { FullScreenError } from '@sine/sine-ui-components';

export default function TeamRequiredPage() {
  return (
    <div>
      <FullScreenError type='no_result' heading='Feature not enabled'>
        Sine Admin isn&apos;t currently available.
      </FullScreenError>
    </div>
  );
}
